import React, { memo, ReactNode, useEffect } from 'react'
import tw from 'twin.macro'
import { ColumnHiddenTooltip } from './ColumnHiddenTooltip'

interface Props {
  hidden: boolean
  columnName: string
  hasValue?: boolean
  onClear?: () => void
  children: ReactNode
}

const FilterColumnGuardComponent = ({ hidden, columnName, hasValue, onClear, children }: Props) => {
  useEffect(() => {
    if (hidden && hasValue && onClear) {
      onClear()
    }
  }, [hidden, hasValue, onClear])

  // `inert` removes the hidden control from the tab order and blocks all
  // interaction; not yet typed on div props in React 18, so spread it loosely.
  const inertProps: any = hidden ? { inert: '' } : {}

  return (
    <ColumnHiddenTooltip disabled={hidden} columnName={columnName}>
      <div
        {...inertProps}
        aria-disabled={hidden}
        css={[tw`inline-flex`, hidden && tw`pointer-events-none opacity-50`]}
      >
        {children}
      </div>
    </ColumnHiddenTooltip>
  )
}

export const FilterColumnGuard = memo(FilterColumnGuardComponent)
